import { useEffect } from 'react'
import { batch, shallowEqual, useDispatch, useSelector } from 'react-redux'
import DashboardTable from 'features/dashboard/table/DashboardTable'
import KeywordTableHeader from 'features/dashboard/table/keyword/KeywordTableHeader'
import {
  clearQiError,
  exitEditable,
  fetchKeywordTable,
  KeywordTableEditTypes,
} from 'features/dashboard/table/keyword/keywordTableSlice'
import { useErrorToast } from 'utils/hooks/useErrorToast'
import ModifyKeywordBiddingStrategyTableHeader from 'features/dashboard/operation/keywordBiddingStrategyEdit/KeywordBiddingStrategyEditTableHeader'
import ModifyKeywordLandingURLTableHeader from 'features/dashboard/operation/keywordLandingUrlEdit/KeywordLandingUrlEditTableHeader'
import { reset as resetKeywordsBiddingStrategy } from 'features/dashboard/operation/keywordBiddingStrategyEdit/keywordsBiddingStrategyEditSlice'
import { reset as resetKeywordLandingURL } from 'features/dashboard/operation/keywordLandingUrlEdit/keywordLandingUrlEditSlice'
import { DashboardTypes } from 'features/Codes'
import useDebounce from 'utils/hooks/useDebounce'
import useDefaultSort from 'features/dashboard/table/column/useDefaultSort'

const KeywordTable = () => {
  const dispatch = useDispatch()
  const {
    common: { from, to },
    filter: { filters },
    table: {
      config: {
        columns: { [DashboardTypes.KEYWORD]: columns },
      },
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
      keywordTable: { page, sort, qiError, editable, editType },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const debouncedColumns = useDebounce(columns, 500)
  useDefaultSort(debouncedColumns)

  useErrorToast({
    error: qiError,
    defaultMessage: '품질지수를 불러오는 중 에러가 발생했습니다.',
    handleClearError: () => dispatch(clearQiError()),
  })

  useEffect(() => {
    const { abort } = dispatch(fetchKeywordTable())
    return () => abort()
  }, [
    dispatch,
    from,
    to,
    page,
    sort,
    campaignIds,
    adGroupIds,
    filters,
    debouncedColumns,
  ])

  useEffect(() => {
    batch(() => {
      dispatch(exitEditable())
      dispatch(resetKeywordsBiddingStrategy())
      dispatch(resetKeywordLandingURL())
    })
  }, [dispatch])

  return (
    <div className="set_table">
      <h4 className="screen_out">키워드 탭 내용</h4>
      {editable ? (
        editType === KeywordTableEditTypes.maxBiddingAmount ? (
          <ModifyKeywordBiddingStrategyTableHeader />
        ) : (
          <ModifyKeywordLandingURLTableHeader />
        )
      ) : (
        <KeywordTableHeader />
      )}
      <DashboardTable />
    </div>
  )
}
export default KeywordTable
